// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { runStorageMigration } from "./utils/storageMigration";
import App from "./App";

// Global styles

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/vendors/fontawesome/css/all.min.css";
import "./assets/vendors/elementskit-icon-pack/assets/css/ekiticons.css";
import "./assets/css/horn.css";

// Must run before any provider reads localStorage — CartContext and AuthProvider
// both hydrate from it during their initial render.
runStorageMigration();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
